import React, { Component } from 'react';

import { Header, Navbar, NavPills } from '@C';
import { RouteSetup } from '@C/Director/Users';
import ErrorBoundary from '@C/Error';
import { authService } from '@S';

const routes = [
  {
    name: 'Manage customers',
    path: '/users/users-list',
  },
];

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <main>
        <div className="page-wrapper">
          <Header title="Referral program" />
          <Navbar />
          <div className="page-content">
            <section className="page-components">
              <div className="page-title"></div>
              <ErrorBoundary>
                <NavPills routes={routes} />
              </ErrorBoundary>
              <ErrorBoundary>
                <RouteSetup />
              </ErrorBoundary>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

export { Users };
